import Link from 'next/link';
import { useContext } from 'react';
import { ABContext } from '../../contexts/ABContext';
import { CartList } from '../../components/Cart/CartList/CartList';
import { CartOrderSummary } from '../../components/Cart/CartOrderSummary/CartOrderSummary';
import { BookingSiteOperated } from '../../components/Misc/BookingSiteOperated/BookingSiteOperated';
import { PageView } from '../../components/Analytics/PageView/PageView';

import styles from './shopping-cart.module.scss';
import Head from 'next/head';;

function ShoppingCart() {

  const ab = useContext(ABContext);

  const title = "Shopping Cart" 

  const shoppingLink = '/express-pass';

  return <>
    <Head key={'privacy-policy'}><title>Universal Orlando™ | Shopping Cart</title></Head>
    <PageView
      pageName='Cart'
    />
    <main className='products'>
      <CartOrderSummary />
      <Link href={shoppingLink} passHref className={styles.back}>Continue Shopping</Link>
      <div className={styles.introArea}>
      <h1 id='maincontent'>{ title }</h1>
      </div>
      <CartList />
    </main>
    <BookingSiteOperated placement="cart" />
  </>;
}

export default ShoppingCart

